module.exports = __webpack_public_path__ + "img/f8.f0989dbe.png";